var _path, _path2, _circle, _circle2, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeverage8560D4Ad15442108Fe8615Cad2Bea8Fe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6438 21.0654C19.3085 20.1348 20.6916 20.1348 21.3563 21.0654L30.6176 34.0313C31.4056 35.1344 30.617 36.6667 29.2614 36.6667H10.7387C9.38308 36.6667 8.59454 35.1344 9.38247 34.0313L18.6438 21.0654Z",
    fill: "#C9D4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.833374 18.3334C0.833374 17.4129 1.57957 16.6667 2.50004 16.6667H10.8334C11.7538 16.6667 12.5 17.4129 12.5 18.3334C12.5 19.2539 11.7538 20.0001 10.8334 20.0001H8.33337V23.3334H31.6667V20.0001H29.1667C28.2462 20.0001 27.5 19.2539 27.5 18.3334C27.5 17.4129 28.2462 16.6667 29.1667 16.6667H37.5C38.4205 16.6667 39.1667 17.4129 39.1667 18.3334C39.1667 19.2539 38.4205 20.0001 37.5 20.0001H35V25.0001C35 25.9206 34.2538 26.6667 33.3334 26.6667H6.66671C5.74623 26.6667 5.00004 25.9206 5.00004 25.0001V20.0001H2.50004C1.57957 20.0001 0.833374 19.2539 0.833374 18.3334Z",
    fill: "#C9D4F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 25.0002,
    r: 1.66667,
    fill: "#496FDF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.29227,
    cy: 11.2924,
    r: 4.62565,
    fill: "#496FDF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.9166,
    cy: 9.58325,
    rx: 6.25,
    ry: 6.25,
    fill: "#496FDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeverage8560D4Ad15442108Fe8615Cad2Bea8Fe);
export default __webpack_public_path__ + "static/media/leverage.8560d4ad15442108fe8615cad2bea8fe.8560d4ad15442108fe8615cad2bea8fe.svg";
export { ForwardRef as ReactComponent };